var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
import { useSafeId } from '../../../core/hooks/useSafeId';
/**
 * @tdr
 */
export var Canada = svgIcon(function (props) {
    var id1 = useSafeId();
    var id2 = useSafeId();
    return (React.createElement("svg", __assign({}, props, { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 12" }),
        React.createElement("g", { clipPath: "url(#".concat(id1, ")") },
            React.createElement("g", { clipPath: "url(#".concat(id2, ")") },
                React.createElement("path", { fill: "#fff", d: "M1.754 0h8.492v12H1.754V0Z" }),
                React.createElement("path", { fill: "red", d: "M-2.49 0h4.244v12H-2.49V0Zm12.736 0h4.244v12h-4.242l-.002-12Zm-7.22 5.798-.332.113L4.23 7.259c.117.344-.04.445-.14.628l1.664-.211-.04 1.676.347-.01-.078-1.664 1.67.2c-.104-.219-.195-.333-.102-.68L9.083 5.92l-.267-.098c-.22-.169.094-.813.14-1.221 0 0-.892.307-.95.145l-.23-.438-.814.895c-.089.021-.126-.014-.148-.089l.375-1.87-.595.335c-.05.023-.098.005-.131-.054l-.574-1.148-.591 1.193c-.044.042-.089.046-.127.018l-.567-.318.342 1.853c-.028.075-.093.094-.168.054l-.78-.883c-.102.164-.17.429-.305.49-.134.056-.586-.113-.889-.179.103.373.427.992.223 1.196v-.003Z" }))),
        React.createElement("rect", { width: "11.7", height: "11.7", x: ".15", y: ".15", stroke: "#53565A", strokeWidth: ".3", rx: "5.85" }),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: id1 },
                React.createElement("rect", { width: "12", height: "12", fill: "#fff", rx: "6" })),
            React.createElement("clipPath", { id: id2 },
                React.createElement("path", { fill: "#fff", d: "M-2.49 0h16.98v12H-2.49z" })))));
});
//# sourceMappingURL=Canada.js.map